import WebDataCard from './WebDataCard';

export default WebDataCard;
